export default __webpack_public_path__ + "static/media/Pot2.943eae5f.svg";